import React from 'react'

function EditGroup() {
  return (
    <div>EditGroup</div>
  )
}

export default EditGroup